import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { Plus } from 'react-feather'
import { DepositTable } from './DepositTable'
import { LinearLoading } from 'common'

export const GPSRemoval = ({useFetchInit}) => {
  const { 
    //------------- Generales
    location,
    paramsURL,
    //------------- globalStates
    globalStates,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions,
    //------------- helpers
    Helpers,
    //------------- Formularios
    Forms  
  } = useFetchInit

  const { FormRequestGlobal } = Forms
  const { formState, onInputChange } = FormRequestGlobal

  const { formOpeningMode} = globalStates

  const { fetchAllDeposits: { loadingFetchDeposits } } = FetchData

  const {handleClickShowModal} = Actions

  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
        Informacion sobre la gestion
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
              <label htmlFor="costo_retiro_gps">Costo Retiro GPS (Q)</label>
              <TextField
                  id='costo_retiro_gps'
                  name='costo_retiro_gps'
                  value={ formState.costo_retiro_gps } 
                  onChange={ onInputChange }
                  size='small'
                  placeholder='costo de retiro'
                  type='text'
                  variant= 'filled'
                  InputProps={{
                      readOnly: true 
                  }}
                  
              />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 2, }}>
        <FormControl fullWidth>
        <label htmlFor="butto_payment">Pago</label>
            <Button
                startIcon={<Plus/>}
                variant='contained'
                sx={{marginBottom: 4}} 
                color='primary' 
                onClick={()=>handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'EDITABLE')}
                disabled={(formOpeningMode==='READONLY')? true : false}
            >
                Agregar Pago
            </Button>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
          <FormControl fullWidth>
            {loadingFetchDeposits && <LinearLoading />}
            <DepositTable useFetchInit={useFetchInit}/>
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
